export enum DataTableSelectionType {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}